import { SEATING_SECTIONS, type SeatingSection } from '@peles/shared';

const OPTIONS: { value: SeatingSection | null; label: string }[] = [
  { value: null, label: 'Mixed' },
  ...SEATING_SECTIONS.map((value) => ({ value, label: value === 'MEN' ? 'Men' : 'Women' })),
];

interface SeatingSectionControlProps {
  /** The table's section, or null for a mixed table. */
  value: SeatingSection | null;
  onChange: (value: SeatingSection | null) => void;
}

/**
 * Which side of the mechitza a table is on — the men's section, the women's,
 * or mixed. Auto-assign's Mechitza strategy seats each party's men and women
 * by it, and the seating screens flag anybody on the wrong side.
 */
export function SeatingSectionControl({ value, onChange }: SeatingSectionControlProps) {
  return (
    <div>
      <span className="block text-xs text-gray-500" id="seating-section-label">
        Section (mechitza)
      </span>
      <div
        role="group"
        aria-labelledby="seating-section-label"
        className="mt-1 grid grid-cols-1 sm:grid-cols-3 gap-1"
        data-testid="seating-section-control"
      >
        {OPTIONS.map((option) => {
          const active = value === option.value;
          return (
            <button
              key={option.label}
              type="button"
              aria-pressed={active}
              onClick={() => onChange(option.value)}
              className={`min-h-11 min-w-11 sm:min-h-0 sm:min-w-0 px-2 py-1 rounded border text-xs ${
                active
                  ? 'border-primary-500 bg-primary-50 text-primary-700 font-medium'
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
